import { apiClient } from 'src/careflow/ph-core/api_client/api_client';
import PatientViewModel from 'src/ccm/careflow/tasks-activities/components/Patients/ViewModel/PatientViewModel';

export type GetPatientsQueryFilters = {
  careTeamIds?: string | null;
  search?: string | null;
  status: string | null;
  pagination: {
    take: number;
    page: 0;
  };
};

export async function getPatients() {
  const data= await apiClient.get(`/ccm/patient/list`);

  return data;
}

export async function getPrograms(fhirPatientId: string) {
  const data= await apiClient.get(`/ccm/patient/${fhirPatientId}/programs`);

  return data;
}

export async function getSummary(careTeamIds: string) {
  const data= await apiClient.get(`/ccm/patient/summary/${careTeamIds ?? ''}`);

  return data;
}

export async function getCcmPatients({
  search,
  status,
  careTeamIds,
  pagination: { take, page },
}: GetPatientsQueryFilters) {
  let url = `/ccm/patient/ccm-list?take=${take}&skip=${page * take}`;

  if (search) {
    url = `${url}&search=${search}`;
  }

  if (status) {
    url = `${url}&status=${status}`;
  }

  if (careTeamIds) {
    url = `${url}&careTeamIds=${careTeamIds}`;
  }

  const data= await apiClient.get<{ patients: PatientViewModel[]; total: number }>(url);

  return data;
}

export async function changeStatus(id: string, status: string) {
  let url = `/crs/patient/change-status/${id}`;

  const data: any = await apiClient.post(url, {
    status,
  });

  return data;
}

export async function addedToProgram(patientId: string, program: string, membership: string) {
  const data= await apiClient.post(`/ccm/patient/${patientId}/programs`, {
    program,
    membership,
  });

  return data;
}

export * as programs from './programs';
